'use client';

import type { ReactNode } from 'react';

import { RecirculationExperiment } from '@/app_components/Article/Related/RecirculationExperiment';
import { AbTest } from '@/app_components/common/AbTest';
import { RecommendedArticles } from '@/app_components/Recommendations/RecommendedArticles';
import type { Classification } from '@/app_lib/types/Article';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';

interface RecommendationExperimentProps {
  currentArticleId: string;
  latestArticlesPromise: Promise<ArticlePreview[]>;
  mostPopularPromise: Promise<ArticlePreview[]>;
  outbrainSlot?: ReactNode;
  recommendationsPromise: Promise<ArticlePreview[] | null>;
  section: Classification['primarySection'];
}

export const RecommendationExperiment = ({
  currentArticleId,
  latestArticlesPromise,
  mostPopularPromise,
  outbrainSlot,
  recommendationsPromise,
  section,
}: RecommendationExperimentProps) => {
  const control = (
    <RecirculationExperiment
      latestArticlesPromise={latestArticlesPromise}
      mostPopularPromise={mostPopularPromise}
      outbrainSlot={outbrainSlot}
      section={section}
    />
  );

  const on = (
    <RecommendedArticles
      currentArticleId={currentArticleId}
      fallbackPromise={latestArticlesPromise}
      recommendationsPromise={recommendationsPromise}
      section={section}
    />
  );

  return (
    <AbTest
      defaultVariant='off'
      flagName='recommendation_engine_enabled'
      variants={{
        off: control,
        on,
      }}
    />
  );
};
